// extracted by mini-css-extract-plugin
export default {"container":"CoctailEddingPage_container__Bh73m","layoutTitle":"CoctailEddingPage_layoutTitle__K8cZX"};